// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  
  background-color: #07070e;
  height: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

label{
  color: #eee;
}

.MuiFormLabel-root{
  color: #eee !important;
}
.MuiFormControl-root{
  color: #eee;
}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper{
  color: #eee !important;
}

/* css for archilogic renders */
* {
  box-sizing: border-box;
}

.map_position {
  height: 100vh;
  width: 100%;
  top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  
}

.loading_overlay {
  font-family: Avenir, Arial, Helvetica, sans-serif;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100000;
  font-size: 36px;
  padding: 100px;
}

.scene {
  width: 40px;
  height: 40px;
  margin: 200px auto;
  perspective: 1000px;
}

.cube {
  width: 40px;
  height: 40px;
  position: relative;
  transform-style: preserve-3d;
  animation: rotateCube 10s infinite;
  animation-timing-function: linear;
}

/* @keyframes rotateCube {
  0% {
    transform: rotateY(0deg) rotateX(0deg) translateZ(0px);
  }
  100% {
    transform: rotateY(360deg) rotateX(-360deg) translateZ(0px);
  }
}

.cube__face {
  position: absolute;
  width: 40px;
  height: 40px;
  border: 2px solid black;
  line-height: 100px;
  font-size: 40px;
  font-weight: bold;
  color: white;
  text-align: center;
}

.cube__face--front {
  transform: rotateY(0deg) translateZ(20px);
}
.cube__face--right {
  transform: rotateY(90deg) translateZ(20px);
}
.cube__face--back {
  transform: rotateY(180deg) translateZ(20px);
}
.cube__face--left {
  transform: rotateY(-90deg) translateZ(20px);
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;IACN,SAAS;IACT,gCAAgC;;AAEpC;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG","sourcesContent":["body {\n  \n  background-color: #07070e;\n  height: 100%;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nlabel{\n  color: #eee;\n}\n\n.MuiFormLabel-root{\n  color: #eee !important;\n}\n.MuiFormControl-root{\n  color: #eee;\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper{\n  color: #eee !important;\n}\n\n/* css for archilogic renders */\n* {\n  box-sizing: border-box;\n}\n\n.map_position {\n  height: 100vh;\n  width: 100%;\n  top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  \n}\n\n.loading_overlay {\n  font-family: Avenir, Arial, Helvetica, sans-serif;\n  box-sizing: border-box;\n  background-color: rgba(255, 255, 255, 0.8);\n  z-index: 100000;\n  font-size: 36px;\n  padding: 100px;\n}\n\n.scene {\n  width: 40px;\n  height: 40px;\n  margin: 200px auto;\n  perspective: 1000px;\n}\n\n.cube {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  transform-style: preserve-3d;\n  animation: rotateCube 10s infinite;\n  animation-timing-function: linear;\n}\n\n/* @keyframes rotateCube {\n  0% {\n    transform: rotateY(0deg) rotateX(0deg) translateZ(0px);\n  }\n  100% {\n    transform: rotateY(360deg) rotateX(-360deg) translateZ(0px);\n  }\n}\n\n.cube__face {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  border: 2px solid black;\n  line-height: 100px;\n  font-size: 40px;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n}\n\n.cube__face--front {\n  transform: rotateY(0deg) translateZ(20px);\n}\n.cube__face--right {\n  transform: rotateY(90deg) translateZ(20px);\n}\n.cube__face--back {\n  transform: rotateY(180deg) translateZ(20px);\n}\n.cube__face--left {\n  transform: rotateY(-90deg) translateZ(20px);\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
